import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign(Object.assign({}, getTestId('DateTimePickerWidgetContainer')), {
  dateTimePickerProps: {
    mode: 'date-time',
    startDate: '',
    variant: 'input',
    inputProps: {
      prependItems: {
        prefixIcon: {
          iconName: 'CalendarIcon'
        }
      },
      showPrepend: false,
      appendItems: {
        postfixIcon: {
          iconName: 'CalendarIcon',
          iconColor: 'black'
        }
      },
      placeholder: 'Select date range',
      showAppend: true
    },
    buttonProps: {
      title: 'Open Date Picker'
    }
  }
});